import { keyframes } from "@emotion/react";
import Box from "@mui/material/Box";
import { useCampaignBuilder } from "@/context/CampaignBuilderContext";

const slideDown = keyframes`
  from { transform: translateY(-10px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
`;

const btnBase =
  "h-8.5 rounded-btn font-lato font-bold text-[11px] tracking-[2px] uppercase px-4 transition-colors";

type Props = {
  addCount: number;
  addMoreTier: number | null;
  onExit: () => void;
  onConfirm: () => void;
};

export default function AddMoreToolbar({ addCount, addMoreTier, onExit, onConfirm }: Props) {
  const { openModal } = useCampaignBuilder();
  return (
    <Box
      sx={{
        px: 3,
        py: 1.5,
        bgcolor: "white",
        animation: `${slideDown} 0.35s ease forwards`,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {/* Left */}
        <Box sx={{ flex: 1 }} />

        {/* Right */}
        <Box sx={{ flex: 1, display: "flex", gap: 1, justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={onExit}
            className={`${btnBase} border border-rodeo-black text-rodeo-black hover:bg-clear-dust`}
          >
            Exit
          </button>
          <button
            type="button"
            onClick={() =>
              openModal({
                context: "addMoreGifts",
                addMoreTier,
                onPrimary: onConfirm,
              })
            }
            disabled={addCount === 0}
            className={`${btnBase} ${
              addCount > 0
                ? "bg-dark-dust text-white hover:opacity-90"
                : "bg-smoke text-graphite cursor-not-allowed"
            }`}
          >
            Add Selected{addCount > 0 ? ` (${addCount})` : ""}
          </button>
        </Box>
      </Box>
    </Box>
  );
}
